import { ReactElement, useEffect } from 'react';
import { UISubNav, useUINav } from '@/ui';
import { useMyCompanyUser } from '@/companies/hooks';
import { usePagesTranslation } from '../hooks';
import { MemberProfileSettingsSection } from '@/companies/components/member-profile-settings-section';
import { MemberTimezoneSettingsSection } from '@/companies/components/member-timezone-settings-section';

export function AccountDetailsSettingsPage(): ReactElement | null {
    const { t } = usePagesTranslation();
    const { setParts } = useUINav();
    useEffect(() => {
        setParts([
            {
                text: t('shared.labels.account')
            },
            { text: t('shared.labels.details') }
        ]);
    }, [setParts, t]);

    const companyUser = useMyCompanyUser();

    if (!companyUser) {
        return null;
    }

    return (
        <div
            style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                padding: 32,
                gap: 24
            }}
        >
            <UISubNav title={t('shared.labels.account_details')} />
            {/* A user always has permission to edit their own details. */}
            <MemberProfileSettingsSection
                companyUser={companyUser}
                canEdit={true}
            />
            <MemberTimezoneSettingsSection
                companyUser={companyUser}
                canEdit={true}
            />
        </div>
    );
}
